import { useEffect, useState } from 'react';

type Listener = (msg: string) => void;
const listeners = new Set<Listener>();

/** Show a short, non-blocking message. Safe to call from anywhere once ToastHost is mounted. */
export function toast(msg: string) {
  listeners.forEach(l => l(msg));
}

export function ToastHost() {
  const [items, setItems] = useState<{ id: number; msg: string }[]>([]);

  useEffect(() => {
    let next = 0;
    const l: Listener = msg => {
      const id = next++;
      setItems(xs => [...xs.slice(-2), { id, msg }]);
      window.setTimeout(() => setItems(xs => xs.filter(x => x.id !== id)), 2200);
    };
    listeners.add(l);
    return () => { listeners.delete(l); };
  }, []);

  return (
    <div className="toast-host" role="status" aria-live="polite">
      {items.map(i => <div key={i.id} className="toast">{i.msg}</div>)}
    </div>
  );
}
